import { Schulform } from "@core/asd/types/schule/Schulform";

export const schulformenGymOb = [Schulform.FW, Schulform.GE, Schulform.GY, Schulform.SG, Schulform.WF] as const;